module.exports = __webpack_public_path__ + "static/media/motto@2x.d338ba57.png";